import { render, staticRenderFns } from "./AccountPermissions.vue?vue&type=template&id=448ec744&scoped=true&"
import script from "./AccountPermissions.vue?vue&type=script&lang=ts&"
export * from "./AccountPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./AccountPermissions.vue?vue&type=style&index=0&id=448ec744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ec744",
  null
  
)

export default component.exports